function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12,2C6.486,2,2,6.486,2,12s4.486,10,10,10s10-4.486,10-10S17.514,2,12,2z M12,20c-4.411,0-8-3.589-8-8 c0-1.168,0.258-2.275,0.709-3.276C4.863,8.814,5.017,8.906,5.165,9c0.396,0.25,0.791,0.5,1.286,0.688C6.945,9.875,7.539,10,8.33,10 c0.792,0,1.386-0.125,1.881-0.313S11.102,9.25,11.498,9s0.792-0.5,1.287-0.688C13.279,8.125,13.873,8,14.665,8 s1.386,0.125,1.88,0.313C17.04,8.5,17.436,8.75,17.832,9s0.792,0.5,1.287,0.688c0.178,0.067,0.374,0.122,0.581,0.171 C19.891,10.541,20,11.257,20,12C20,16.411,16.411,20,12,20z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 12.5,
  r: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 12.5,
  r: 1.5
});

function SvgAddAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    style: {
      fill: "rgba(0, 0, 0, 1)",
      transform: "",
      msFilter: ""
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAvatar);
export default __webpack_public_path__ + "static/media/addAvatar.66c3f0c8.svg";
export { ForwardRef as ReactComponent };